import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IFaireIcon) {
    (function(Type) {
        Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
        Type["RESPONSIBLE_CONSUMPTION_AND_PRODUCTION"] = "RESPONSIBLE_CONSUMPTION_AND_PRODUCTION";
        Type["SPROUT"] = "SPROUT";
        Type["SHARE_HEART"] = "SHARE_HEART";
        Type["CHECK_OUTLINE"] = "CHECK_OUTLINE";
        Type["ARROW"] = "ARROW";
        Type["INSIDER_KEY"] = "INSIDER_KEY";
        Type["ACCOUNT"] = "ACCOUNT";
        Type["ADD"] = "ADD";
        Type["ANNOUNCEMENT"] = "ANNOUNCEMENT";
        Type["ANNOUNCEMENT_MUTED"] = "ANNOUNCEMENT_MUTED";
        Type["APPLICATION"] = "APPLICATION";
        Type["BLOCK"] = "BLOCK";
        Type["BOOKMARK_TAG"] = "BOOKMARK_TAG";
        Type["CALENDAR"] = "CALENDAR";
        Type["CART_EMPTY"] = "CART_EMPTY";
        Type["CART_ITEMS"] = "CART_ITEMS";
        Type["CAUTION"] = "CAUTION";
        Type["CHAT_BUBBLE"] = "CHAT_BUBBLE";
        Type["CHEVRON"] = "CHEVRON";
        Type["CLOCK"] = "CLOCK";
        Type["CLOSE"] = "CLOSE";
        Type["CUSTOMER_SUPPORT"] = "CUSTOMER_SUPPORT";
        Type["DIAMOND"] = "DIAMOND";
        Type["EARN"] = "EARN";
        Type["EDIT"] = "EDIT";
        Type["EMAIL"] = "EMAIL";
        Type["ESTIMATED_DELIVERY_DATE"] = "ESTIMATED_DELIVERY_DATE";
        Type["EXCLAMATION"] = "EXCLAMATION";
        Type["EXCLAMATION_SOLID"] = "EXCLAMATION_SOLID";
        Type["EXCLUSIVITY"] = "EXCLUSIVITY";
        Type["EXPAND"] = "EXPAND";
        Type["EYE"] = "EYE";
        Type["EYE_CLOSED"] = "EYE_CLOSED";
        Type["FILTER"] = "FILTER";
        Type["GLOBE"] = "GLOBE";
        Type["GROUP"] = "GROUP";
        Type["HEART"] = "HEART";
        Type["INFORMATION"] = "INFORMATION";
        Type["LINK"] = "LINK";
        Type["LOCK"] = "LOCK";
        Type["MINIMIZE"] = "MINIMIZE";
        Type["PARTY_POPPER"] = "PARTY_POPPER";
        Type["PAYMENT_PLAN"] = "PAYMENT_PLAN";
        Type["PIN"] = "PIN";
        Type["RELATIONSHIPS"] = "RELATIONSHIPS";
        Type["RETURNS"] = "RETURNS";
        Type["SAVE"] = "SAVE";
        Type["SEARCH"] = "SEARCH";
        Type["SEND"] = "SEND";
        Type["SHARE"] = "SHARE";
        Type["SHIPMENT_DELIVERED"] = "SHIPMENT_DELIVERED";
        Type["SHIPPING"] = "SHIPPING";
        Type["SHIPS_FROM"] = "SHIPS_FROM";
        Type["SHOPPING_BAG"] = "SHOPPING_BAG";
        Type["SORT"] = "SORT";
        Type["STAR"] = "STAR";
        Type["STAR_FILLED"] = "STAR_FILLED";
        Type["SYNCHRONIZED"] = "SYNCHRONIZED";
        Type["SYNCHRONIZED_WARNING"] = "SYNCHRONIZED_WARNING";
        Type["TRASH_CAN"] = "TRASH_CAN";
        Type["TRUCK"] = "TRUCK";
        Type["TWINKLE"] = "TWINKLE";
        Type["UNDO"] = "UNDO";
        Type["VERTICAL_ELLIPSIS"] = "VERTICAL_ELLIPSIS";
        Type["ALARM_CLOCK"] = "ALARM_CLOCK";
        Type["CHECK_IN_CIRCLE"] = "CHECK_IN_CIRCLE";
        Type["SHOPIFY_COLORED"] = "SHOPIFY_COLORED";
        Type["SQUARE"] = "SQUARE";
        Type["CLOVER"] = "CLOVER";
        Type["TROPHY_ICON_SECONDARY"] = "TROPHY_ICON_SECONDARY";
        Type["CIRCLE_FILLED"] = "CIRCLE_FILLED";
        /**
     * Faire Summer Market icon
     * https:www.figma.com/design/mDFMOehyo1z5YWGDxh2lXV/%F0%9F%8C%9E-Faire-Summer-Market-2024?node-id=3447-94271&t=Zxab8MMQyLmiGeAd-0
     */ Type["FAIRE_SUMMER_MARKET"] = "FAIRE_SUMMER_MARKET";
        Type["ADD_USER"] = "ADD_USER";
        Type["NOTIFICATION_BELL"] = "NOTIFICATION_BELL";
        Type["NOTIFICATION_BELL_CHECKED"] = "NOTIFICATION_BELL_CHECKED";
        Type["ARROW_TOP"] = "ARROW_TOP";
    })(IFaireIcon.Type || (IFaireIcon.Type = {}));
    IFaireIcon.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IFaireIcon || (IFaireIcon = {}));
export var IFaireIcon;
